module.exports = __webpack_public_path__ + "img/eqzouFGE.778b36ad.svg";